import { useEffect } from 'react';
import { loadAuth, useAuth } from '../sync/authStore';
import { startUploadQueue } from '../sync/uploadQueue';
import { Window } from '../ui/Window';
import { BoardPage } from './BoardPage';
import { Dashboard } from './Dashboard';
import { LoginPage } from './LoginPage';
import { RegisterPage } from './RegisterPage';
import { SharePage } from './SharePage';
import { Workspace } from './Workspace';
import { useRoute } from './router';

export function App() {
  const route = useRoute();
  const status = useAuth((s) => s.status);
  const setupNeeded = useAuth((s) => s.setupNeeded);

  useEffect(() => {
    void loadAuth();
    void startUploadQueue();
  }, []);

  // Share links work with or without an account; the server grants access per session.
  if (route.name === 'share') return <SharePage key={route.token} token={route.token} view={route.view} />;

  // Local boards never talk to the server, so they work logged out and offline.
  if (route.name === 'local') return <BoardPage key={route.id} boardId={route.id} remote={false} view={route.view} />;

  if (status === 'loading') {
    return (
      <main className="desktop">
        <Window title="VDS">
          <p>Connecting…</p>
        </Window>
      </main>
    );
  }

  if (status === 'anon') {
    if (route.name === 'register' || setupNeeded) {
      return <RegisterPage invite={route.name === 'register' ? route.invite : null} setup={setupNeeded} />;
    }
    return <LoginPage />;
  }

  switch (route.name) {
    case 'board':
      return <Workspace primary={route.id} split={route.split} view={route.view} />;
    default:
      return <Dashboard />;
  }
}
